import React from 'react';
import { useQuery } from '@tanstack/react-query';
import DashboardSection from './components/DashboardSection';
import DashboardPage from './components/DashboardPage';
import CompletionSummary from './components/CompletionSummary';
import AgencyQueueTable from './components/AgencyQueueTable';
import useDashboardScope from './useDashboardScope';

import { statValue, readAgencyQueue } from './stats';

const PassportDashboard = () => {
  const { api, campaignYear, enabled, queryOptions, scope } = useDashboardScope();
  const query = useQuery({
    ...queryOptions,
    queryKey: ['trip/stats/visa/', ...scope],
    queryFn: api.list('trip/stats/visa/', { year: campaignYear }),
  });
  const stats = query.data?.data?.data;
  const counts = {
    total: statValue(stats, 'Passeports attendus'),
    deposited: statValue(stats, 'Passeports déposés'),
    awaiting: statValue(stats, 'Passeports en attente'),
  };
  const data = Object.values(counts).every(Number.isFinite)
    ? { ...counts, agencies: readAgencyQueue(stats, 'deposited') }
    : null;
  return (
    <DashboardPage
      ariaLabel="Tableau de bord passeports"
      title="Tableau de bord passeports"
      subtitle={`Campagne ${campaignYear || 'indisponible'}`}
      enabled={enabled}
      queries={[query]}
      hasCompleteData={!!data}
      errorMessage="Actualisation impossible"
    >
      <DashboardSection title="Dépôt des passeports" query={query} available={!!data}>
        {data && (
          <CompletionSummary
            total={data.total}
            completed={data.deposited}
            awaiting={data.awaiting}
            label="Passeports déposés"
          />
        )}
      </DashboardSection>
      <DashboardSection title="Passeports en attente par société" query={query} available={!!data}>
        {data && <AgencyQueueTable rows={data.agencies} completedKey="deposited" completedLabel="Déposés" />}
      </DashboardSection>
    </DashboardPage>
  );
};
export default PassportDashboard;
